import { combineReducers } from 'redux';

import { SELECTED_DEALER_ID, SELECTED_GROUP_ID, SEARCH, ROLES, SORT } from 'constants/FilterConstants';
import { filterSliceAdapter } from 'modules/global/reducers/filterSliceAdapter';
import searchReducer from 'modules/global/reducers/simpleSearchReducer';
import * as types from 'modules/users/actionTypes';
import { createReducer } from 'utils/ReduxUtils';

/** @typedef { 'text' | 'roles' | 'groupId' | 'dealerId' | 'sort' } ImpersonateFilterField */

/**
 * @typedef {{
 *   open: boolean,
 *   filters: Record<ImpersonateFilterField, string> & { roles: string[] },
 *   data: import('modules/global/reducers/simpleSearchReducer').SimpleSearchReducer,
 * }} ImpersonateReducer
 */

const emptyState = {
  [ROLES]: [],
  [SEARCH]: null,
  [SELECTED_GROUP_ID]: null,
  [SELECTED_DEALER_ID]: null,
  [SORT]: 'displayName,asc',
};

/** @type {FilterAdapter<PaymentsFiltersReducer>} */
const filterAdapter = filterSliceAdapter(emptyState);

export default combineReducers({
  open: createReducer(false, {
    [types.OPEN_IMPERSONATE_MODAL]: () => true,
    [types.CLOSE_IMPERSONATE_MODAL]: () => false,
  }),
  filters: createReducer(filterAdapter.getInitialState(), {
    [types.SET_IMPERSONATE_MODAL_FILTER]: filterAdapter.setFilter,
    [types.SET_IMPERSONATE_MODAL_FILTERS]: filterAdapter.setFilters,
    [types.CLEAR_IMPERSONATE_MODAL_FILTER]: filterAdapter.resetFilters,
    [types.REMOVE_IMPERSONATE_MODAL_FILTER]: filterAdapter.removeFilter,
  }),
  data: searchReducer(types.FETCH_USERS_REQUEST, {
    global: {
      paginationSlice: true,
      matcher: ({ meta }) => meta.source === 'impersonate',
    },
  }),
});
